import {otsBaseApi} from "../../ots-api";
import {TeamMembership} from "../../../model/team-membership";

const ALL_TAG_TYPES = [
  "TeamMemberships"
] as const;

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

export const teamApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Teams a person belongs to. People may always read their own; anyone else's needs team view access. */
    getTeamMembershipsByPerson: builder.query<TeamMembership[], string>({
      query: (personId) => ({
        url: `/teams/memberships/${personId}`,
        method: "GET"
      }),
      providesTags: (result, error, personId) => [{type: "TeamMemberships", id: personId}]
    })
  })
});

export const {
  useGetTeamMembershipsByPersonQuery
} = teamApi;
